import { call, put } from 'redux-saga/effects';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../../redux/notifications/actions';
import { tableConfig } from '../../settings/index';
import { groupLogs } from './helpers';

const getLoadData = (logListActions, api, sections) => {
  function* loadData({ payload }) {
    try {
      const {
        page = 1,
        pageSize = tableConfig.pageSize,
        column,
        order,
        filter = '',
        id,
        actions = [],
        partners = [],
      } = payload;

      const result = yield call(
        sendRequest,
        api.load,
        {
          search: {
            ...payload,
            page,
            pageSize,
            column,
            order,
            filter,
            actions,
            partners,
          },
          id,
        },
        notifications.REQUEST_ERROR,
      );

      if (result) {
        const resultData = (result.data.success || result).data;
        const { data, records, totalCount, filteredCount, sortableColumns, filters } = resultData;
        const isGrouped = !!sections;

        const logsRecords = records || data || [];
        const logs = isGrouped ? groupLogs([...logsRecords], sections) : logsRecords;

        yield put(
          logListActions.loadDataSuccess({
            logs,
            total: totalCount,
            filteredTotal: filteredCount,
            sortableColumns,
            filters,
          }),
        );
      }
    } catch (error) {
      logger.error(error);
    }
  }

  return loadData;
};

export { getLoadData };
